import { Link } from 'react-router-dom';

const PREVIEW_BOOKMAKERS = ['Bet365', 'Betsson', 'Bwin', 'Unibet', 'Pinnacle'];

const PREVIEW_ROWS = [
  { label: '1 · Local',  odds: [2.10, 2.08, 2.12, 2.09, 2.18] },
  { label: 'X · Empate', odds: [3.40, 3.35, 3.38, 3.40, 3.45] },
  { label: '2 · Visitante', odds: [3.60, 3.55, 3.65, 3.58, 3.75] },
];

export default function LiveOddsPreview() {
  const getBest = (row: number[]) => Math.max(...row);

  return (
    <section className="py-24 bg-[#151719]">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-[#ff6b35] text-xs font-bold tracking-widest uppercase mb-3">
              <span className="inline-flex items-center gap-1.5">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#ff6b35] opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-[#ff6b35]"></span>
                </span>
                CUOTAS EN DIRECTO
              </span>
            </p>
            <h2 className="text-white text-4xl font-black uppercase">
              ENCUENTRA LA MEJOR<br />
              <span className="text-white/50">CUOTA EN SEGUNDOS</span>
            </h2>
          </div>
          <Link
            to="/comparador"
            className="flex items-center gap-2 px-6 py-3 border border-[#2a2d3a] text-[#a8b2c1] rounded-xl hover:border-[#00e87a]/30 hover:text-[#00e87a] transition-all text-sm font-semibold whitespace-nowrap cursor-pointer"
          >
            <span>Ver cuotas en tiempo real</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="bg-[#0d0f14] border border-[#2a2d3a] rounded-2xl overflow-hidden">
          <div className="flex flex-col sm:flex-row items-center justify-between px-6 py-4 border-b border-[#2a2d3a] gap-3">
            <span className="text-[#6b7280] text-xs">UEFA Champions League</span>
            <div className="flex items-center gap-4">
              <span className="text-white font-black text-lg">Local</span>
              <span className="px-3 py-1 bg-[#1e2028] rounded-lg text-[#6b7280] font-black text-sm">vs</span>
              <span className="text-white font-black text-lg">Visitante</span>
            </div>
            <div className="flex items-center gap-1.5 text-[#ff6b35] text-xs font-bold">
              <span className="w-1.5 h-1.5 rounded-full bg-[#ff6b35] animate-pulse inline-block"></span>
              Cuotas en tiempo real
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full min-w-[560px]">
              <thead>
                <tr className="border-b border-[#1e2028]">
                  <td className="px-6 py-3 text-[#6b7280] text-xs font-semibold">MERCADO</td>
                  {PREVIEW_BOOKMAKERS.map((bm) => (
                    <td key={bm} className="px-4 py-3 text-center text-[#a8b2c1] text-xs font-bold">{bm}</td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {PREVIEW_ROWS.map((row) => {
                  const best = getBest(row.odds);
                  return (
                    <tr key={row.label} className="border-b border-[#1e2028]/50">
                      <td className="px-6 py-3 text-[#a8b2c1] text-sm font-medium whitespace-nowrap">{row.label}</td>
                      {row.odds.map((val, i) => (
                        <td key={i} className="px-4 py-3 text-center">
                          <span className={`px-3 py-1.5 rounded-lg text-sm font-bold tabular-nums inline-block ${
                            val === best
                              ? 'bg-[#00e87a]/15 text-[#00e87a] border border-[#00e87a]/30'
                              : 'text-white'
                          }`}>
                            {val.toFixed(2)}
                          </span>
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="px-6 py-4 border-t border-[#2a2d3a] flex items-center justify-between flex-wrap gap-3">
            <p className="text-[#6b7280] text-xs">
              Las cuotas en verde son las más altas disponibles. Datos de Bet365, Betsson, Bwin, Unibet y Pinnacle.
            </p>
            <Link to="/comparador" className="text-[#ff6b35] text-xs font-bold hover:underline cursor-pointer whitespace-nowrap">
              Comparar partidos reales →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
